<template>
  <div class="search_container searchArea">
    <el-form
      :inline="true"
      :model="search_data"
      ref="search_data"
      class="demo-form-inline search-form"
    >
      <el-form-item label>
        <el-tag size="medium" effect="dark">会员:{{ this.user.name }}</el-tag>
      </el-form-item>
      <el-form-item label="">
        <el-date-picker
          v-model="search_data.year"
          type="year"
          placeholder="选择年"
          value-format="yyyy"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="">
        <el-date-picker
          v-model="search_data.month"
          type="month"
          placeholder="选择月"
          value-format="yyyy-MM"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="">
        <el-date-picker
          v-model="search_data.date"
          align="right"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          size="mini"
          icon="search"
          @click="onScreeoutMoney()"
          >筛选</el-button
        >
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          size="mini"
          icon="search"
          @click="onDownloadClasshourSpendRecord()"
          >导出课时账单</el-button
        >
      </el-form-item>
      <el-form-item class="btnRight">
        <el-button
          v-show="ROLE == 1"
          type="primary"
          size="mini"
          icon="view"
          @click="onAddClassHourSpend()"
          >添加</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getToken } from "@/utils/auth";
import { excelDownloadClasshour } from "@/api/classhourspend";
import { addOperationRecord } from "@/api/operationrecord";

export default {
  name: "searchItem",
  data() {
    return {
      search_data: {
        stdName: "",
        year: "",
        month: "",
        date: "",
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      ROLE: 0,
    };
  },
  props: {
    username: String,
  },
  computed: {
    ...mapGetters(["user"]),
  },
  created() {
    this.ROLE = getToken("ROLE");
  },
  methods: {
    onScreeoutMoney() {
      console.log(this.search_data);
      this.$store.commit("SET_CLASSHOUR_SPEND_SEARCH", this.search_data);
      this.$emit("changePageAndLimit");
      this.$emit("searchList");
    },
    onAddClassHourSpend() {
      this.$emit("showDialog", "add");
    },
    onDownloadClasshourSpendRecord() {
      console.log("导出会员课时账单");
      const para = { username: this.username };
      console.log(para);
      excelDownloadClasshour(para).then((res) => {
        const content = res;
        const blob = new Blob([res.data], {
          type: " application/vnd.ms-excel",
        });
        const a = document.createElement("a");
        // 生成文件路径
        let href = window.URL.createObjectURL(blob);
        a.href = href;
        let _fileName = decodeURIComponent(
          res.headers["content-disposition"].split(";")[1].split("=")[1]
        );
        // 文件名中有中文 则对文件名进行转码
        a.download = _fileName;
        // 利用a标签做下载
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(href);
        // this.$store.commit("SET_BUTTON_STATUS1", false);
        // this.$store.commit("SET_BUTTON_TEXT1", "点击生成excel");
        const para = {
          userName: getToken("USERNAME"),
          content: "导出课时账单",
        };
        addOperationRecord(para).then((res) => {
          console.log(res);
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.search_container {
  margin-bottom: 20px;
}
.btnRight {
  float: right;
  margin-right: 0px !important;
}
.searchArea {
  background: rgba(255, 255, 255, 1);
  border-radius: 2px;
  padding: 18px 18px 0;
}
</style>
